import backLayout from '@/components/common/background/Layout'
//import leftLayout from '@/components/common/background/LeftLayout'
import frontLayout from '@/components/common/front/Layout'

import settingsLayout from '@/components/common/settings/Layout'


// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV);

/**
 * 在后台内显示
 */
const background = [{
  path: '/',
  redirect: {
    name: 'home'
  },
  component: backLayout,
  children: [{
      path: "/scanacc",
      name: "scanacc",
      meta: {
        title: "扫码入账",
        auth: true
      },
      component: _import('pages/scanacc/index.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },

    {
      path: "/invoice",
      name: "invoice",
      meta: {
        title: "发票",
        auth: true
      },
      component: _import('pages/invoice/index.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    {
      path: "/invoice/olap",
      name: "olapInvoice",
      meta: {
        title: "多维分析",
        auth: true
      },
      component: _import('pages/invoice/olap.vue')
    },
    {
      path: "/collect/invoice",
      name: "collectInvoice",
      meta: {
        title: "进项发票",
        auth: true
      },
      component: _import('pages/invoice/collect_index.vue')
    },
    {
      path: "/collect/paper/download",
      name: "paperDownload",
      meta: {
        title: "批量导出管理",
        auth: true
      },
      component: _import('pages/invoice/paper_download_list.vue')
    },
    {
      path: "/salesInvoice",
      name: "salesInvoice",
      meta: {
        title: "进项发票",
        auth: true
      },
      component: _import('pages/sales/index.vue')
    },
    {
      path: "/invcheck",
      name: "invcheck",
      meta: {
        title: "审核记录",
        auth: true
      },
      component: _import('pages/invcheck/index.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    {
      path: "/archive",
      name: "archive",
      meta: {
        title: "档案",
        auth: true
      },
      component: _import('pages/invoice/archive.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    {
      path: "/risk",
      name: "risk",
      meta: {
        title: "风险",
        auth: true
      },
      component: _import('pages/invoice/risk.vue')
    },
    {
      path: "/archive/paperStat",
      name: "paperStat",
      meta: {
        title: "档案",
        auth: true
      },
      component: _import('pages/invoice/paper_stat.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    {
      path: "/attachment",
      name: "attachment",
      meta: {
        title: "附件",
        auth: true
      },
      component: _import('pages/attachment/index.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    {
      path: "/pwdchange",
      name: "pwdchange",
      meta: {
        title: "更改密码",
        auth: true
      },
      component: _import('pages/user/password-change.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    {
      path: "/home",
      name: "home",
      meta: {
        title: "首页",
        auth: true
      },
      component: _import('pages/home/index.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    {
      path: "/orgs",
      name: "orgs",
      meta: {
        title: "机构",
        auth: true
      },
      component: _import('pages/org/index.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    {
      path: "/orgfin",
      name: "orgfin",
      meta: {
        title: "机构帐户",
        auth: true
      },
      component: _import('pages/orgfin/index.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    {
      path: "/rechargeAdmin",
      name: "rechargeAdmin",
      meta: {
        title: "充值管理",
        auth: true
      },
      component: _import('pages/orgfin/rechargeAdmin.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    {
      path: "/settings",

      redirect: "/settings/basic",
      component: settingsLayout,
      children: [{
          path: "/settings/basic",
          name: "basic",
          meta: {
            title: "基本信息",
            auth: true
          },
          component: _import('pages/settings/basic.vue')
          // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
        },
        {
          path: "/settings/mail-account",
          name: "mail-account",
          meta: {
            title: "邮箱账号",
            auth: true
          },
          component: _import('pages/settings/mail_account.vue')
          // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
        },
        {
          path: "/settings/ent",
          name: "ent",
          meta: {
            title: "企业信息",
            auth: true
          },
          component: _import('pages/settings/ent.vue')
          // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
        },
        {
          path: "/settings/mail-whitelist",
          name: "mail-whitelist",
          meta: {
            title: "发件人白名单",
            auth: true
          },
          component: _import('pages/settings/mail_whitelist.vue')
          // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
        },
        {
          path: "/settings/prod-blacklist",
          name: "prod-blacklist",
          meta: {
            title: "商品黑名单",
            auth: true
          },
          component: _import('pages/settings/prod_blacklist.vue')
          // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
        },
        {
          path: "/settings/users",
          name: "users",
          meta: {
            title: "用户管理",
            auth: true
          },
          component: _import('pages/settings/users.vue')
          // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
        },
        {
          path: "/settings/recharge",
          name: "recharge",
          meta: {
            title: "充值记录",
            auth: true
          },
          component: _import('pages/settings/recharge.vue')
          // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
        },
        {
          path: "/settings/trans",
          name: "trans",
          meta: {
            title: "计费",
            auth: true
          },
          component: _import('pages/settings/trans.vue')
          // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
        }
      ]
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },

    {
      path: "/tcs/upload-task",
      name: "tcs-upload-task",
      meta: {
        title: "数据汇总上报",
        auth: true
      },
      component: _import('pages/tcs/uploadtask/index.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },

    {
      path: "/tcs/upload-task-list",
      name: "tcs-upload-task-list",
      meta: {
        title: "数据汇总上报",
        auth: true
      },
      component: _import('pages/tcs/uploadtask/list.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },

    {
      path: "/tcs/view",
      name: "tcs-view",
      meta: {
        title: "文件查看",
        auth: true
      },
      component: _import('pages/tcs/uploadtask/viewer.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },

    {
      path: "/tcs/ent-tax",
      name: "ent-tax",
      meta: {
        title: "企业税负预警",
        auth: true
      },
      component: _import('pages/tcs/enttax/index.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },

    {
      path: "/tcs/ent-req",
      name: "ent-req",
      meta: {
        title: "需求提报",
        auth: true
      },
      component: _import('pages/tcs/entreq/list.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    {
      path: "/tcs/stat",
      name: "tcs-stat",
      meta: {
        title: "月度统计",
        auth: true
      },
      component: _import('pages/tcs/stat/chart.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },

    {
      path: "/tcs/ent",
      name: "tcs-ent",
      meta: {
        title: "企业信息",
        auth: true
      },
      component: _import('pages/tcs/uploadtask/ent.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    // {
    //   path: 'user',
    //   name: 'user',
    //   meta: {
    //     title: '用户管理',
    //     auth: true
    //   },
    //   component: _import('pages/user')
    // }


  ]
}];

const front = [{
  path: '/login',
  redirect: {
    name: 'login'
  },
  component: frontLayout,
  children: [{
      path: "/login",
      name: "login",
      meta: {
        title: "登录",
        auth: false
      },
      component: _import('system/login/Login.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    {
      path: "/view",
      name: "view",
      meta: {
        title: "发票查看",
        auth: false
      },
      component: _import('pages/invoice/view.vue')
      // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
    },
    {
      path: "/register",
      name: "register",
      meta: {
        title: "用户注册",
        auth: false
      },
      component: _import('system/login/userreg.vue')
    },
    {
      path: "/passwordreset",
      name: "passwordreset",
      meta: {
        title: "密码重置",
        auth: false
      },
      component: _import('system/login/reset_password.vue')
    },
  ]
}];

/**
 * 在主框架之外显示
 */
const frameOut = [
  {
    path: "/imageViewer",
    name: "imageViewer",
    meta: {
      title: "图片浏览",
      auth: false
    },
    component: _import('pages/invcheck/image_viewer.vue')
    // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
  },

  {
    path: "/viewer",
    name: "viewer",
    meta: {
      title: "版式文件浏览",
      auth: false
    },
    component: _import('pages/invcheck/viewer.vue')
    // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
  },

  {
    path: "/viewer2",
    name: "viewer2",
    meta: {
      title: "发票预览",
      auth: false
    },
    component: _import('pages/invoice/viewer2.vue')
    // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
  },
  {
    path: "/camera",
    name: "camera",
    meta: {
      title: "发票上传",
      auth: false
    },
    component: _import('pages/invcheck/camera.vue')
    // component: () => import( /* webpackChunkName: "admin-dashboard" */ '@/components/common/dashboard/Index.vue'),
  },
];

/**
 * 错误页面
 */
const errorPage = [{
  path: '*',
  name: '404',
  component: _import('system/error/404')
}];

// 导出需要显示菜单的
export const frameInRoutes = background;

// 重新组织后导出
export default [
  ...background,
  ...front,
  ...frameOut,
  ...errorPage
]